import * as React from 'react';

import { observer } from 'mobx-react';

import { Button } from '@estee/elc-buttons';

import classnames from 'classnames';

import { MessageType } from '~constants/Constants';

export interface IAlertProps {
    children: React.ReactNode;
    messageType?: MessageType;
    showCloseButton?: boolean;
    onClose?(): void;
}

interface IAlertActionContainerProps {
    children: React.ReactNode;
    className?: string;
}

const TEST_ID_ALERT = 'elc-iam-alert';
const TEST_ID_ALERT_TITLE = 'elc-iam-alert-title';
const TEST_ID_ALERT_CONTENT = 'elc-iam-alert-content';

const baseClassName = 'elc-iam-alert';
const titleClassName = `${baseClassName}-title`;
const actionContainerClassName = `${baseClassName}-action-container`;
const contentClassName = `${baseClassName}-content`;
const iconClassName = `${baseClassName}-icon`;
const closeButtonClassName = `${baseClassName}-close-button`;

export const AlertTitle = observer(({ children }: { children: React.ReactNode }) => {
    return (
        <div className={titleClassName} data-test-id={TEST_ID_ALERT_TITLE}>
            {children}
        </div>
    );
});

export const AlertActionContainer = observer(
    ({ children, className }: IAlertActionContainerProps) => {
        return <div className={classnames(actionContainerClassName, className)}>{children}</div>;
    }
);

export const Alert = observer((props: IAlertProps) => {
    const { messageType = MessageType.WARNING, children, showCloseButton = false, onClose } = props;

    return (
        <div
            className={classnames(baseClassName, `${baseClassName}-${messageType}`)}
            data-test-id={TEST_ID_ALERT}
        >
            <div className={iconClassName} />
            <div className={contentClassName} data-test-id={TEST_ID_ALERT_CONTENT}>
                {children}
            </div>
            {showCloseButton && (
                <div className={closeButtonClassName}>
                    <Button onClick={onClose} />
                </div>
            )}
        </div>
    );
});
